import { Component, OnInit, Input } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Product } from '../../entities/product.entities'
import { ProductService } from '../../services/product.service'

@Component({
  selector: 'app-rice-spacial',
  templateUrl: './rice-spacial.component.html',
  styleUrls: ['./rice-spacial.component.css']
})
export class RiceSpacialComponent implements OnInit {

  @Input('data') meals: string[] = [];
  page: number = 1;

  private products: Product[] = [];
  constructor(private productService: ProductService,private titleService: Title) { }
  ngOnInit() {
    this.titleService.setTitle("ข้าวไทยเกรดพรีเมี่ยม");
    this.productService.getProduct().subscribe((snapshot) => {
      let index: number = 0;
      for (var i = 0; i < snapshot.length; i++) {
        if (snapshot[i].type == '2') {
          this.products[index] = snapshot[i]
          index++;
        }
      }
    });
  }
}



// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/rice-spacial/rice-spacial.component.ts